import { createContext } from 'react';

import type { PaginationContextReturnValue } from '#pagination/context/types/context-return-value.type';

/**
 * React context for pagination state and actions.
 *
 * Provides the pagination context value throughout the component tree.
 * The context value conforms to the `PaginationContextReturnValue` type,
 * or is `undefined` if not provided.
 *
 * @see PaginationContextReturnValue
 */
export const PaginationContext = createContext<PaginationContextReturnValue | undefined>(undefined);
